import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { serviceRequestVerbiage } from 'helpers/VerbiageHelper';

import { reportRouter, clearReport } from 'actions/insightsActions';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

import MenuHeader from 'components/shared/MenuHeader';

const superScript = {
  verticalAlign: 'super',
  fontSize: '9px',
  fontFamily: 'Circular',
  color: AccentColor(),
};

const ReportDescription = ({
  reportDescription,
  reportTitle,
  reportRouter,
  disabled,
  ...otherProps
}) => {
  return (
    <div className="col-sm-6 col-md-4" style={{ paddingTop: '15px', minHeight: '160px' }}>
      <h5>
        {reportTitle}
        {disabled ? <span style={superScript}>Coming Soon!</span> : <span />}
      </h5>
      <p style={{ textAlign: 'justify' }}> {reportDescription} </p>
      <div className="row" style={{ textAlign: 'center' }}>
        <FlatButton
          disabled={disabled}
          label="Select"
          onClick={reportRouter}
          primary={true}
          backgroundColor={disabled ? colors.GRAY : AccentColor()}
          hoverColor="grey"
          style={{
            color: 'white',
            height: '40px',
          }}
        />
      </div>
    </div>
  );
};

export default connect(
  store => ({
    accountingEnabled: store.userTypes.accountingEnabled,
    maintenanceEnabled: store.userTypes.maintenanceEnabled,
    multiFamilyEnabled: store.userTypes.multiFamilyEnabled,
  }),
  { reportRouter, clearReport }
)(
  class Reporting extends Component {
    // use asyncMode when you want to do pulling, see report.rb.
    reportCreator = (reportType, options = { asyncMode: false }) => {
      this.props.reportRouter(
        { report_type: reportType, is_accrual: true, date_range: {} },
        options.asyncMode
      );
    };

    componentDidMount() {
      this.props.clearReport();
    }

    render() {
      return (
        <div className="body" role="main">
          <div className="centers">
            <div>
              <div className="stage-header clearfix" style={{ marginBottom: '15px' }}>
                <span className="page-title">Report Selection</span>
              </div>
              {this._renderOperationsReports()}
              {this._renderMaintenanceReports()}
              {this._renderCapreitReports()}
              <div style={{ height: '100px' }} />
            </div>
          </div>
        </div>
      );
    }

    _renderCapreitReports = () => {
      if (!hostIsCapreit()) return;

      return (
        <Fragment>
          <MenuHeader menuTitle="CAPREIT Reports" />
          <div className="row" style={{ marginBottom: '30px' }}>
            <ReportDescription
              reportTitle="Tenant Email and Phone Number Change"
              reportDescription="Shows an events log of all tenant phone number and email changes."
              reportRouter={() => this.reportCreator('capreit_tenant_name_change_report')}
            />
          </div>
        </Fragment>
      );
    };

    _renderMaintenanceReports = () => {
      if (!this.props.maintenanceEnabled) return;

      return (
        <Fragment>
          <MenuHeader menuTitle="Maintenance Reports" />
          <div className="row" style={{ marginBottom: '30px' }}>
            <ReportDescription
              reportTitle="Maintenance Log"
              reportDescription="Shows a maintenance log of ticket statuses over a designated period of time."
              reportRouter={() => this.reportCreator('maintenance_log', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle={`${serviceRequestVerbiage('titlecase')}s`}
              reportDescription={`Shows ${serviceRequestVerbiage()} performance over a designated period of time.`}
              reportRouter={() => this.reportCreator('maintenance_tickets', { asyncMode: true })}
            />
          </div>
        </Fragment>
      );
    };

    _renderOperationsReports = () => {
      if (!this.props.multiFamilyEnabled) return;

      return (
        <Fragment>
          <MenuHeader menuTitle="Operations Reports" />
          <div className="row" style={{ marginBottom: '30px' }}>
            <ReportDescription
              reportTitle="Rent Roll Report"
              reportDescription="Shows a full rent roll report, showing tenants, rent amounts, and lease details."
              reportRouter={() => this.reportCreator('rent_roll', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Payments Report"
              reportDescription="Shows all reported and paid payments."
              reportRouter={() => this.reportCreator('payments_report')}
            />

            <ReportDescription
              reportTitle="Deposits Report"
              reportDescription="Shows all reported and paid deposits."
              reportRouter={() => this.reportCreator('deposits_report')}
            />

            <ReportDescription
              reportTitle="Signed Leases Report"
              reportDescription="Shows a summary of all signed leases, showing tenants, rent amounts, and lease details."
              reportRouter={() => this.reportCreator('leases')}
            />

            <ReportDescription
              reportTitle="Showings Report (Book Date)"
              reportDescription="Shows a report on all showings, whether conversions occurred, and no shows. Sorted by the booked date."
              reportRouter={() =>
                this.reportCreator('showings_by_booked_date', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Showings Report (Showing Date)"
              reportDescription="Shows a report on all showings, whether conversions occurred, and no shows. Sorted by showing date."
              reportRouter={() =>
                this.reportCreator('showings_by_showing_date', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Applications Report"
              reportDescription="Shows a report on all applications created, created, completed and cancelled."
              reportRouter={() => this.reportCreator('applications', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Vacancy"
              reportDescription="Lists all of your vacant units with key insights (such as time on market)."
              reportRouter={() => this.reportCreator('vacancy_report', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Ancillary Items"
              reportDescription="Shows all ancillary items with key insights (such as vacancy, market rent etc.)."
              reportRouter={() => this.reportCreator('ancillary_items')}
            />

            <ReportDescription
              reportTitle="Maintenance Log"
              reportDescription="Shows a maintenance log of ticket statuses over a designated period of time."
              reportRouter={() => this.reportCreator('maintenance_log', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle={`${serviceRequestVerbiage('titlecase')}s`}
              reportDescription={`Shows ${serviceRequestVerbiage()} performance over a designated period of time.`}
              reportRouter={() => this.reportCreator('maintenance_tickets', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Lead Marketing Source Report"
              reportDescription="Shows a report of the marketing source per lead data"
              reportRouter={() => this.reportCreator('lead_marketing_report', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Prospect Data"
              reportDescription="Shows a report of prospect data"
              reportRouter={() => this.reportCreator('prospect_data_report', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Resident Data"
              reportDescription="Shows a report of resident data"
              reportRouter={() => this.reportCreator('resident_data_report', { asyncMode: true })}
            />

            <ReportDescription
              reportTitle="Detailed Resident Data"
              reportDescription="Shows a detailed report of resident data"
              reportRouter={() =>
                this.reportCreator('detailed_resident_data_report', { asyncMode: true })}
            />
          </div>
        </Fragment>
      );
    };
  }
);
